import createReactComponent from '../createReactComponent';
import { IconNode } from '../types';

export const __iconNode: IconNode = [["path",{"d":"M17 8a2 2 0 0 1 2 2v4a2 2 0 1 1 -4 0v-4a2 2 0 0 1 2 -2z","key":"svg-0"}],["path",{"d":"M10 8a2 2 0 0 1 2 2v4a2 2 0 1 1 -4 0v-4a2 2 0 0 1 2 -2z","key":"svg-1"}],["path",{"d":"M5 16h.01","key":"svg-2"}]]

const IconDecimal = createReactComponent('outline', 'decimal', 'Decimal', __iconNode);

export default IconDecimal;